function safeImageUrl(url) {
  if (url.includes('.jpg')) return url.split('.jpg')[0] + '.jpg?width=200';
  if (url.includes('.png')) return url.split('.png')[0] + '.png?width=200';
  return url;
}
function createProductCard(product) {
  let html = '';
    
  html += `
      <div class="spinner-overlay">
        <div class="spinner"></div>
      </div>
      <a class="server-product-link" href="" title="${product.title}">
        <div class="server-product-image">
          ${product.images && product.images.length > 0 ? 
            `<img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-olsrc="${safeImageUrl(product.images[0])}" alt="${product.title}" height="190px" class="collection_product_card_img">` : '<img src="https://onlineimages.techmikeny.com/oimages/generic/ics.png" class="collection_product_card_img" alt="Product Image Coming Soon" height="190px">'}
        </div>
        <div class="collection_product_card_title">${product.title}</div>
        ${product.price ? 
            `<div class="collection_product_card_price">${parseFloat(product.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</div>` : ''}
       <div id="productDescription" class="collection_product_card_desc"> 
            ${product.description_html ? product.description_html : 'No description available.'} 
        </div>
      </a>
      
      <div class="product-card-actions" style=" padding: 10px; margin-top: 10px;">
        ${product.variant_id && product.inventory_quantity > 0 && product.type !== "server_chassis" && product.type !== "Server Chassis" && !product.type.toLowerCase().includes('memory') ? 
          `<button class="add-to-cart-btn btn 
              product-form__cart-submit 
              collection_product_card_add_2_cart_btn" 
              data-variant-id="${product.variant_id}" 
              data-product-title="${product.title}"
              style="
                width: 100%;
                margin-top: 0px !important;
                padding: 10px 20px;
                background-color: #0095ff;
                color: white;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;
                transition: background-color 0.3s ease;
                margin-bottom: 10px;
              "
              onmouseover="this.style.backgroundColor='#0056b3'"
              onmouseout="this.style.backgroundColor='#0095ff'">
            <span class="btn-text">Add to Cart</span>
            <span class="btn-spinner" style="display: none;">
              <span style="display: inline-block; width: 16px; height: 16px; border: 2px solid #ffffff; border-radius: 50%; border-top-color: transparent; animation: spin 1s linear infinite;"></span>
              Adding...
            </span>
          </button>` 
          : product.type === "server_chassis" || product.type === "Server Chassis"?
          `<button class="add-to-cart-btn btn 
              product-form__cart-submit 
              start_build_btn
              collection_product_card_add_2_cart_btn" 
              data-variant-id="${product.variant_id}" 
              data-product-title="${product.title}"
              style="
                width: 100%;
                padding: 10px 20px;
                background-color: #0095ff;
                color: white;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                font-weight: bold;
                cursor: pointer;
                transition: background-color 0.3s ease;
                margin-bottom: 10px;
                margin-top: 0px !important;

              "
              onmouseover="this.style.backgroundColor='#0056b3'"
              onmouseout="this.style.backgroundColor='#0095ff'">

            <span class="btn-text">${product.cto_hash ? 'Resume Build' : 'Start Build'}</span>
            <span class="btn-spinner" style="display: none;">
              <span style="display: inline-block; width: 16px; height: 16px; border: 2px solid #ffffff; border-radius: 50%; border-top-color: transparent; animation: spin 1s linear infinite;"></span>
              Loading...
            </span>
          </button>`  : !product.type.toLowerCase().includes('memory') ?
          `<button class="add-to-cart-btn btn 
              product-form__cart-submit 
              collection_product_card_add_2_cart_btn" 
              disabled 
              style="
                width: 100%;
                padding: 10px 20px;
                background-color: #6c757d;
                color: white;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                font-weight: bold;
                cursor: not-allowed;
                margin-bottom: 10px;
                margin-top: 0px !important;

              ">
            Out of Stock
          </button>` : `<button class="add-to-cart-btn btn 
              product-form__cart-submit 
              collection_product_card_add_2_cart_btn" 
               
              style="
                width: 100%;
                padding: 10px 20px;
                background-color: #6c757d;
                color: white;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 10px;
                margin-top: 0px !important;

              "
              onclick="window.location.href='/products/${product.handle}'"
              >
            View now
          </button>`
        }
        
        <a href="/products/${product.handle}" 
           class="view-details-btn"
           style="
             display: block;
             width: 100%;
             padding: 10px 20px;
             background-color: transparent;
             color: #0095ff;
             border: 2px solid #0095ff;
             border-radius: 5px;
             text-align: center;
             text-decoration: none;
             font-size: 14px;
             font-weight: bold;
             transition: all 0.3s ease;
             box-sizing: border-box;
           "
           onmouseover="this.style.backgroundColor='#0095ff'; this.style.color='white';"
           onmouseout="this.style.backgroundColor='transparent'; this.style.color='#0095ff';">
          View Details
        </a>
      </div>
  `;

  setTimeout(() => {
    init();
  }, 250);
  return html;
}
function init() {
  var imgDefer = document.getElementsByTagName('img');
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('data-olsrc') && imgDefer[i].getAttribute('src') !== imgDefer[i].getAttribute('data-olsrc')) {
      imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-olsrc'));
    }
  }
}
const addVariantToCart = async (variantId, quantity = 1, productTitle) => {
  try {
      const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
          },
          body: JSON.stringify({
              items: [{
                  id: variantId,
                  quantity: quantity
              }]
          })
      });

      if (!response.ok) {
          throw new Error('Failed to add item to cart');
      }

      const result = await response.json();
      
      showCartMessage('Item added to cart successfully!', 'success', productTitle);
      
      updateCartCount();
      
      return result;
  } catch (error) {
      console.error('Error adding to cart:', error);
      showCartMessage('Failed to add item to cart. Please try again.', 'error');
      throw error;
  }
};

const showCartMessage = (message, type = 'success', productTitle = '') => {


  if (type === 'success') {
      Swal.fire({
          icon: 'success',
          title: 'Added to Cart!',
          text: productTitle ? `${productTitle} has been added to your cart.` : message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          showCloseButton: true,
          customClass: {
              popup: 'colored-toast'
          }
      });
  try{
    let cartCount = parseInt(document.getElementById('cartCount').innerText);
    document.getElementById('cartCount').innerText = cartCount + 1;
  } catch (err){
  }
  } else {
      Swal.fire({
          icon: 'error',
          title: 'Error',
          text: message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
          showCloseButton: true,
          customClass: {
              popup: 'colored-toast'
          }
      });
  }
};

const updateCartCount = async () => {
  try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCountElement = document.querySelector('#desktop-cart-li a ');
      cartCountElement.innerHTML = `<span class="material-icons-outlined navbar-icon">
            shopping_cart
          </span> ${ cart.item_count}`
      
  } catch (error) {
      console.error('Error updating cart count:', error);
  }
};


function reportClickedReccomendation(clickedSku, href, currSku) {
  const customerId = localStorage.getItem('lsid');
  const reqUrl = 'https://apiapi.ombligo.com/thompsonRecs';

  const payload = {
    sku: currSku,
    clicked_sku: clickedSku,
    user_id: customerId ? `${customerId}` : null
  };

  const beaconData = new Blob([JSON.stringify(payload)], { type: 'application/json' });

  if (!navigator.sendBeacon(reqUrl, beaconData)) {
    console.warn('sendBeacon failed, falling back to fetch');
    fetch(reqUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }).catch(err => console.error("Error reporting clicked recommendation:", err));
  }

  if (currSku && currSku !== 'null' && currSku !== '' && currSku !== undefined) {
    let redirectUrl = `/products/${href}?recd=${currSku}`;
    window.location.href = redirectUrl;
  } else {
    window.location.href = `/products/${href}`;
  }
}





async function loadReccomendedProducts(currSku) {
  const customerId = localStorage.getItem('lsid');
  const reqUrl = new URL('https://apiapi.ombligo.com/thompsonRecs');
  
  reqUrl.searchParams.append('sku', currSku);

  if (customerId) {
    reqUrl.searchParams.append('user_id', customerId);
  }

  try {
    const response = await fetch(reqUrl);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();

    const targetElement = document.querySelector('#personalRecsContent');
    if (!targetElement) {
      console.error('Target element #personalRecsContent not found');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const recSku = el.dataset.sku;

          if (!recSku || el.dataset.tracked === 'true') return;

          el.dataset.tracked = 'true';

          const impressionPayload = {
            sku: currSku,
            impression_sku: recSku,
            user_id: customerId
          };

          const impressionUrl = 'https://apiapi.ombligo.com/impression';
          const impressionData = new Blob([JSON.stringify(impressionPayload)], { type: 'application/json' });

          if (!navigator.sendBeacon(impressionUrl, impressionData)) {
            console.warn('sendBeacon failed, falling back to fetch');
            fetch(impressionUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken() 
              },
              body: JSON.stringify(impressionPayload)
            }).catch(err => console.error("Impression error:", err));
          }

          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    for (let i = 0; i < data.length; i++) {
      const product = data[i];
      if (!product || !product.sku || !product.handle || !product.title || product.title === '' || product.title === 'null') {
        console.warn('Skipping invalid product:', product);
        continue;
      }

      const productHTML = createProductCard(product);
      const productContainer = document.createElement('div');
      productContainer.className = 'collection_product_card_container recommended-item';
      productContainer.innerHTML = productHTML;

      productContainer.dataset.sku = product.sku;
      productContainer.dataset.handle = product.handle;
      productContainer.dataset.title = product.title;
      

      observer.observe(productContainer);


      if (productContainer) {
        productContainer.addEventListener('click', function (e) {
          e.preventDefault();
          reportClickedReccomendation(product.sku, product.handle, currSku);
        });
      }


      const addVariantToCartBtn = productContainer.querySelector('.add-to-cart-btn');
      if (addVariantToCartBtn && !addVariantToCartBtn.disabled) {
        if (addVariantToCartBtn.classList.contains('start_build_btn')) {
          addVariantToCartBtn.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();

            const btnText = this.querySelector('.btn-text');
            const btnSpinner = this.querySelector('.btn-spinner');
            
            btnText.style.display = 'none';
            btnSpinner.style.display = 'inline-block';
            this.disabled = true;
            window.location.href = `/products/${product.handle}`;

          });
        } else {
          addVariantToCartBtn.addEventListener('click', async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const variantId = this.getAttribute('data-variant-id');
            const productTitle = this.getAttribute('data-product-title');
            const btnText = this.querySelector('.btn-text');
            const btnSpinner = this.querySelector('.btn-spinner');
            
            btnText.style.display = 'none';
            btnSpinner.style.display = 'inline-block';
            this.disabled = true;
            
            try {
              const numericVariantId = variantId.includes('gid://shopify/ProductVariant/') 
                ? variantId.split('/').pop() 
                : variantId;
              
              await addVariantToCart(numericVariantId, 1, productTitle);
              
              // trackRecommendationConversion(product.sku, currSku, customerId);
              
            } catch (error) {
              console.error('Failed to add recommended product to cart:', error);
            } finally {
              btnText.style.display = 'inline-block';
              btnSpinner.style.display = 'none';
              this.disabled = false;
            }
          });
        }
      }

      targetElement.appendChild(productContainer);
    }

    if (data.length > 0) {
      document.querySelector('#personalRecs').style.display = 'contents';
    }

  } catch (error) {
    console.error('Error loading recommended products:', error);
  }

  function getCSRFToken() {
    const cookie = document.cookie.match(/csrftoken=([^;]+)/);
    return cookie ? cookie[1] : '';
  }
}








function openModal4CollectionProductCard(productId) {
    /**
    @description: Selects div tags with class attr val `collection_product_overlay` and `collection_product_modal_container`. Applies
    Css to both el to create UI modal and sets modal container to have same HTML structure and vals 
    as the product card
    @param {HTML} productId: HTML product card structure, el, and vals 
    **/
    product_id = productId; 
    let modalOverlay    = htmlEl('.collection_product_overlay'), 
        modalContainer  = htmlEl('.collection_product_modal_container'), 
        closeModalBtn   = createHtmlEl('div')
        ; 
        
    modalOverlay.style.display      = 'block'; 
    document.body.style.overflow    = 'hidden'; 
    modalContainer.style.display    = 'block'; 
    modalContainer.style.width      = 'max-content';

    modalContainer.innerHTML = htmlEl(`#modal_product_card_id_${productId}`).innerHTML; // copies product card to collection_product_modal_container 
    let modalDescHtmlEl = modalContainer.querySelector('.collection_product_card_desc'); 

    closeModalBtn.classList  = 'closeModalBtn'; 
    closeModalBtn.innerHTML  = '&times;'; 

    if (modalDescHtmlEl.clientHeight > 185) {
        modalDescHtmlEl.style.height = '250px'; 
        modalDescHtmlEl.style.overflowY = 'auto'; 
    }
    // applyProductCardCover(productId); 
    modalContainer.appendChild(closeModalBtn); 
    closeModalBtn.addEventListener('click', closeModal4CollectionProductCard); 
    showFullProductDetails4Over200(modalContainer); 
    applyMobileStyleTo(modalDescHtmlEl); 

}



function showFullProductDetails4Over200(modalContainer) {
    /**
    @description: Expands css line clamp, removes product card's 'See Full Desc', 
    `.collection_product_overlay`, and `collection_product_modal_container`. Effectivly cleans up modal container artifacts. 
    @param {HTML} modalContainer: An html div el that contains info from product card 
    **/
    modalContainer.querySelector('.collection_product_card_desc').style.webkitLineClamp = '999';
    modalContainer.querySelector('.collection_product_overlay').remove() 
    modalContainer.querySelector('.collection_product_modal_container').remove() 
}



function applyProductCardCover(productId) {
    /**
    @description: Renders 'Add to cart' and 'buy now' btns
    **/ 
    document.getElementById(`product_card_id_${productId}`).querySelector('.over_200_product_card_cover').style.display = 'block'; 
}



function closeModal4CollectionProductCard() {
    /**
    @description: closes the modal by changing css property display to none
    **/
    let modalOverlay    = htmlEl('.collection_product_overlay'), 
        modalContainer  = htmlEl('.collection_product_modal_container')
    ; 
    modalOverlay.style.display = 'none';
    modalContainer.style.display = 'none';
    document.body.style.overflow = ''; // Restore scrolling
    modalContainer.innerHTML = ''; // Clear the modal content
}


function applyMobileStyleTo(modalDescHtmlEl) {
    /**
    @description: Applies special CSS val for mobile view 
    @param {HTML} modalDescHtmlEl: HTML el pertaining to the modal desc field 
    **/
    if (window.screen.width <= 415 && window.screen.height <= 915) {  
        modalDescHtmlEl.style.height = '325px'; 
        modalDescHtmlEl.style.overflowY = 'auto'; 
    }
}



function applyOrRemoveStyles() {
    /**
    @description: fn to apply or remove the styles based on the window size
    **/
    if (window.innerWidth >= 720) {
        document.querySelectorAll('.search_res_modal_btns_container').forEach(btns_container => {
            // Add your styles for window.innerWidth >= 720px here, or you can remove any specific style properties.
            btns_container.style.position = 'absolute';
            btns_container.style.top = '560px';
            btns_container.style.right = '10.1px';   
        });
    } 
}
i = 0;
function flashElement(element) {
    speed = 100;
    
        setTimeout(function () {
            element.style.transform = 'scale(1.34)';
            element.style.transform = 'saturation(1.8)'
            setTimeout(function () {
                element.style.transform = 'scale(1)';
                element.style.transform = 'saturation(1)'
                if (i < 2){ flashElement(element); }
                i++;
            }, speed);
        }, speed);

}

function clearCheckedArray() {
    checkedArray = [];
    // Clear any checkboxes if needed
    let checkedCheckboxes = document.querySelectorAll('input[type=checkbox]:checked');
    document.getElementById('compare-clear-buttons').remove();
    for (let checkbox of checkedCheckboxes) {
        checkbox.checked = false;
    }
}

let checkedArray = [];
compare = false;

function boxChecked(event) {

    // Reset the checkedArray when the function is called.
    checkedArray = [];

    // Retrieve all checked checkboxes.
    let checked = document.querySelectorAll('input[type=checkbox]:checked');
    if (checked.length > 3) {
        checked[0].checked = false;
        document.getElementById('compare-' + checked[0].id).style.opacity = 0.5;
        checked = document.querySelectorAll('input[type=checkbox]:checked');
    }
    let unchecked = document.querySelectorAll('input[type=checkbox]:not(:checked)');
    for (let i = 0; i < unchecked.length; i++) {
        document.getElementById('compare-' + checked[0].id).style.opacity = 0.5;
    }

    if (checked.length > 3) {

        checked[0].checked = false;
        document.getElementById('compare-' + checked[0].id).style.opacity = 0.5;


    }

    // Populate the checkedArray with the IDs of checked checkboxes.
    for (let i = 0; i < checked.length; i++) {
        checkedArray.push(checked[i].id);
        document.getElementById('compare-' + checked[i].id).style.opacity = 1;
        //document.getElementById('compare-' + checked[i].id).style.transform = 'scale(1)';

        document.getElementById('compare-' + checked[i].id).setAttribute('onclick', 'openModalForComparison()');

    }

    // Remove duplicates from the checkedArray.
    checkedArray = [...new Set(checkedArray)];



    
    }








const attributeLabels = {
    'processors': 'Processor',
    'no_cores': 'Cores',
    'processors_clockspeed': 'CPU Speed',
    'total_mem_cap': 'Total RAM',
    'memory_speed': 'Memory Speed',
    'mem_type': 'Memory Type',
    'mem_cap_per_mod': 'Capacity per Module',
    'mem_no_inst': 'Modules installed',
    'raid_controller':'RAID Controller',
    'storage': 'Storage Capacity',
    'nic': 'NIC',
    'rails': 'Rails',
    'software': 'Software',
    'remote_ac': 'Remote Access',
    'price': 'Price',
};

function openModalForComparison() {
    const modalOverlay = document.querySelector('.collection_product_overlay');
    const modalContainer = document.querySelector('.collection_product_modal_container');
    if (!modalOverlay || !modalContainer) {
        console.error('Modal elements are missing!');
        return;
    }

    removeExistingTable(modalContainer);
    setupModalDisplay(modalOverlay, modalContainer);

    const table = createComparisonTable();
    modalContainer.appendChild(table);

    const closeModalBtn = createCloseButton();
    modalContainer.appendChild(closeModalBtn);
    closeModalBtn.addEventListener('click', closeModal4CollectionProductCard);
}



function removeExistingTable(container) {
    const existingTable = container.querySelector('.compare-table');
    if (existingTable) {
        container.removeChild(existingTable);
    }
}

function setupModalDisplay(overlay, container) {
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    Object.assign(container.style, {
        display: 'block',
        maxWidth: '90%',
        width: 'min-content',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        overflowX: 'auto'
    });
}

function createComparisonTable() {
    const table = document.createElement('table');
    table.classList.add('compare-table');
    table.style.border = 'none';

    const tableHead = createTableHead();
    table.appendChild(tableHead);

    const tableBody = createTableBody();
    table.appendChild(tableBody);

    styleTableRows(table);

    return table;
}

function createTableHead() {
    const tableHead = document.createElement('thead');
    const tableHeadRow = document.createElement('tr');

    const emptyCell = document.createElement('th');
    tableHeadRow.appendChild(emptyCell);

    // Add a header cell for the primary product
    const primaryHeaderCell = createHeaderCell('{{ product.title }}');
    tableHeadRow.appendChild(primaryHeaderCell);

    checkedArray.forEach(id => {
        const productNumber = id.replace('product', '');
        const productTitle = document.querySelector(`#collection_product_card_container${productNumber} .collection_product_card_title`);
        const url = document.getElementById(`collection_product_card_container${productNumber}`).dataset.url;

        const cell = createHeaderCell(productTitle.textContent, () => window.location.href = url);
        tableHeadRow.appendChild(cell);
    });

    tableHead.appendChild(tableHeadRow);
    return tableHead;
}

function createTableBody() {
    const tableBody = document.createElement('tbody');
    tableBody.appendChild(createImageRow());
    appendAttributeRows(tableBody);
    return tableBody;
}

function createCloseButton() {
    const closeButton = document.createElement('div');
    closeButton.classList.add('closeModalBtn');
    closeButton.innerHTML = '&times;';
    return closeButton;
}

function createHeaderCell(text, onClick = null) {
    const cell = document.createElement('th');
    cell.innerHTML = text.length > 90 ? `${text.slice(0, 90)}...` : text;
    cell.style.cursor = 'pointer';
    if (onClick) {
        cell.addEventListener('click', onClick);
    }
    return cell;
}

function createImageRow() {
    const row = document.createElement('tr');

    const emptyCell = document.createElement('td');
    row.appendChild(emptyCell); // Placeholder for alignment under attribute labels

    const primaryProductImageCell = document.createElement('td');
    const primaryImage = document.createElement('img');
    primaryImage.src = "{{product|img_url: '300x300'}}";
    primaryImage.style.borderRadius = '8px';
    //primaryImage.style.cursor = 'pointer';
    primaryProductImageCell.appendChild(primaryImage);
    //primaryProductImageCell.onclick = () => window.location.href = "{{ product.url }}";
    row.appendChild(primaryProductImageCell);

    checkedArray.forEach(id => {
        const productNumber = id.replace('product', '');
        const productImage = document.querySelector(`#collection_product_card_container${productNumber} .collection_product_card_img`);
        const productUrl = document.getElementById(`collection_product_card_container${productNumber}`).dataset.url;

        const cell = document.createElement('td');
        const image = document.createElement('img');
        image.src = productImage.src;
        image.style.borderRadius = '8px';
        image.style.cursor = 'pointer';
        cell.appendChild(image);
        cell.onclick = () => logAndRedirect(productUrl);
        row.appendChild(cell);
    });

    return row;
}


function appendAttributeRows(tableBody) {
    Object.entries(attributeLabels).forEach(([attr, label]) => {
        const row = document.createElement('tr');
        const labelCell = document.createElement('td');
        labelCell.innerHTML = label;
        row.appendChild(labelCell);

        // Add cell for primary product
        const primaryAttrCell = document.createElement('td');
        if (attr == 'price'){ 
            primaryAttrCell.innerHTML = '$' + primaryProductData[attr];

        } else {
            primaryAttrCell.innerHTML = primaryProductData[attr];
        }
        //primaryAttrCell.style.cursor = 'pointer';
        //primaryAttrCell.onclick = () => window.location.href = "{{ product.url }}"; // Assumes primary product URL is available
        row.appendChild(primaryAttrCell);

        checkedArray.forEach(id => {
            const productNumber = id.replace('product', '');
            const productData = document.getElementById(`collection_product_card_container${productNumber}`).dataset;
            const productUrl = productData.url;

            const cell = document.createElement('td');
            cell.innerHTML = productData[attr] ? formatAttributeValue(attr, productData[attr]) : 'N/A';
            cell.style.cursor = 'pointer';
            cell.onclick = () => logAndRedirect(productUrl);
            row.appendChild(cell);
        });

        tableBody.appendChild(row);
    });
}


function formatAttributeValue(attr, value) {
    if (attr === 'storage') {
        return value.length > 3 ? `${value / 1000} TB` : `${value} GB`;
    }
    return value;
}
function styleTableRows(table) {
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach((row, index) => {
        if (index % 2 === 1) {
            row.style.backgroundColor = '#ababab62';
            row.style.border = 'none';
        }
    });
}

